export const DEFAULT_LAYOUT = {
  entityTableId: "agent-workflow-runs",
  defaultPageSize: 20,
  defaultSort: { attributeId: "ran_at", direction: "desc" },
  defaultDisplayedAttributes: [
    "ran_at",
    "state",
    "status",
    "summary",
    "type",
    "provider",
    "triggered_by",
    "ran_by",
    "duration_ms",
    "token_usage"
  ],
  defaultColumnOrder: [
    "ran_at",
    "state",
    "status",
    "summary",
    "type",
    "provider",
    "triggered_by",
    "ran_by",
    "duration_ms",
    "token_usage"
  ]
};
